import type {RuleValidationErrors} from '../types';
import {CheckoutType} from './constants';
import type {CheckoutsRule} from './types';
import {createValidationObject} from '../../utils/createValidationObject';

export const validateCheckoutsRule = <T extends CheckoutsRule = CheckoutsRule>(
	rule: T,
): RuleValidationErrors | false => {
	if (rule.elementSubType1 === CheckoutType.ALL && rule.elementValue1 !== 0)
		return {
			elementValue1: createValidationObject(),
		};

	if (
		rule.elementSubType1 === CheckoutType.USER_ID &&
		(typeof rule.elementValue1 !== 'number' || rule.elementValue1 <= 0)
	)
		return {
			elementValue1: createValidationObject(),
		};

	return false;
};

export default validateCheckoutsRule;
